import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Tabs,
  Tab,
  Badge,
  Chip,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
// components
import Page from '../components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import Iconify from '../components/Iconify';
import client from 'src/api/clients';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Label from 'src/components/Label';
import { DeviceForm, DeviceList } from 'src/sections/devices';
import { getDevices } from 'src/api/devices'
import { getClientList, getTimezoneList } from 'src/api/analytics';
import DeviceDetails from 'src/sections/devices/DeviceDetails';

// ----------------------------------------------------------------------

export default function Devices({isReseller}) {
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const resellerDefaultTab = resellerClientType === 'INDIA' ? 'india' : 'us';
  const tabListSx = {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.neutral,
    '& .MuiTab-root': { color: theme.palette.text.secondary },
    '& .MuiTab-root.Mui-selected': { color: theme.palette.text.primary },
    '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main },
  };
  
  const [devices, setDevices] = useState({
    isLoad: false,
    all: [],
    active: [],
    inActive: [],
    lastId: null
  })
  //const [userType, setUserType] = useState(localStorage.getItem('user_type'))

  const [totalData,setTotalData]=useState({})

  const [clientId,setClientId]=useState([])

  const [selectedClient, setSelectedClient] = useState([]);
  const [environmentType, setEnvironmentType] = useState('production');

  const [clientListUS,setClientListUS]=useState([]) 
  const [clientListINDIA,setClientListINDIA]=useState([]) 


  const [displayAll,setDisplayAll] = useState(false)
  const [value, setValue] = useState('one');
  const [valueMain, setValueMain] = useState(isReseller ? resellerDefaultTab : 'us');

  const [allDevices, setAllDevices] = useState([]); 
  const [allClients, setAllClients] = useState([]);  
  const [timezoneDetails,setTimezone] = useState([]);

  const [apiResponse,setApiResponse] = useState(false)


  const getClientId = (clientid) =>{    
    if(clientid.selectedClients){
      let id=clientid.selectedClients.map(item=>item.ID)
      setClientId(id)
    }
  }

  useEffect(() => {
    const fetchTimezoneList =  async () => {
      getTimezoneList((response) => {
        if (response.status === 200) {
          // console.log("Time Zone ", response.data);
          setTimezone(response.data)    
        }
      });
    }

    fetchTimezoneList();
  },[])

  useEffect(() => {
    
  setApiResponse(false)
  const fetchData = async () => {
    const body = { status: "0,1", limit: 0 };

    try {
     
        getDevices(body, (response) => {
          
           let totalCams=response.data;
            if (response.status == 200) { 
                getClientList((res) => {
                  

                  if(res.data.length>0){

                    console.log(res.data);

                    const indiaClients = res.data.filter(
                      (row) => row.ClientType === 'INDIA' && row.Type === null
                    );
    
                    const usClients = res.data.filter(
                      (row) => row.ClientType === 'US' && row.Type === null
                    );

                    const sortedDataIND = [...indiaClients].sort((a,b)=>
                      a.displayname.trim().localeCompare(b.displayname.trim())
                    )

                    usClients
  .filter(x => !x.displayname)
  .forEach(x => {
    console.log("Client with missing displayname:", {
      ClientID: x.ClientID,
      Id: x.Id,
      displayname: x.displayname,
      client: x
    });
  });
                    const sortedDataUS = [...usClients].sort((a,b)=>
                      a.displayname.trim().localeCompare(b.displayname.trim())
                    )
                    setClientListUS(sortedDataUS)
                    setClientListINDIA(sortedDataIND)
                  }
                  const allDevices = totalCams || [];
                  const allClients = res.data || [];

                  setAllDevices(allDevices);
                  setAllClients(allClients);

                  // initial filtering (US or INDIA based on default tab)
                  filterData(allDevices, allClients, valueMain);
                })
            }
        })
        
    } catch (error) {
      console.error("Error fetching devices/clients:", error);
    }
  };

  fetchData();
}, []); 

  useEffect(() => {
    if (isReseller) {
      setValueMain(resellerDefaultTab);
    }
  }, [isReseller, resellerDefaultTab]);

  const matchesEnvironment = (clientItem, selectedEnvironment = environmentType) => {
    if (selectedEnvironment === 'all') return true;
    const expectedEnvironment = selectedEnvironment === 'demo' ? 0 : 1;
    return Number(clientItem?.EnvironmentType) === expectedEnvironment;
  };

  useEffect(() => {
    if (Array.isArray(allDevices) && Array.isArray(allClients) && allClients.length) {
      filterData(allDevices, allClients, valueMain);
    }
  }, [allDevices, allClients, valueMain, environmentType]);


const filterData = (devices, clients, region) => {
  
      const regionClients = clients.filter(
        (row) => row.ClientType === region.toUpperCase() && row.Type === null && matchesEnvironment(row)
      );
      const clientIds = regionClients.map((c) => c.ID);

      const filteredDevices = devices.filter((d) => clientIds.includes(d.clientid));
      const active = filteredDevices.filter((d) => d.Status === 1);
      const inActive = filteredDevices.filter((d) => d.Status === 0);

      setDevices({
        isLoad: true,
        all: filteredDevices,
        active,
        inActive,
        lastId:
          filteredDevices.length > 0
            ? filteredDevices[filteredDevices.length - 1].uid
            : 0,
      });

      setTotalData(filteredDevices);
      setApiResponse(true)
    };


  const handleReloadPage = () => {
   
    
    const body = { status: "0,1", limit: 0 }
    getDevices(body, (response) => {
      let totalCams=response.data;
      //console.log(clientId)
      if (response.status == 200) { 
        getClientList((response) => {
          if (response.status === 200) {
            const indiaClients = response.data.filter(
              (row) => row.ClientType === 'INDIA' && row.Type === null && matchesEnvironment(row)
            );
        
            const usClients = response.data.filter(
              (row) => row.ClientType === 'US' && row.Type === null && matchesEnvironment(row)
            );
            if(valueMain === "us"){
              // console.log("==========usClients",usClients);
              const clientIdsUS = usClients.map(client => client.ID);

              const active = []
              const inActive = []
              let lastId = body.lastid
              if (totalCams) {
                if(selectedClient.length===0){
                 totalCams=totalCams.filter(item=>clientIdsUS.includes(item.clientid))

                 setTotalData(totalCams)
                  totalCams.forEach((row) => {
                    if (row.Status === 1)
                      active.push(row)
                    else if (row.Status === 0)
                      inActive.push(row)
                  })
                  lastId = totalCams[totalCams.length-1].uid
                }
                else{
                 //totalCams = totalCams.filter(item => item.ID.some(id => selectedClient.includes(id)));
                 totalCams = totalCams.filter(item=>selectedClient.some(item2=>item2.ID===item.clientid));
                  
                 totalCams.forEach((row) => {
                    if (row.Status === 1)
                      active.push(row)
                    else if (row.Status === 0)
                      inActive.push(row)
                  })
                  lastId =totalCams.length>0?totalCams[totalCams.length-1].uid:0
                }
               
              }       
              setDevices({ 
                ...devices,
                all: totalCams ? totalCams : [],
                active: active,
                inActive: inActive,
                lastId: lastId,
                isLoad: totalCams.length === body.limit ? !devices.isLoad: devices.isLoad
                //isLoad:true
              })
            
            }
            else{
              // console.log("==========indiaClients",indiaClients);
              const clientIdsIND = indiaClients.map(client => client.ID);

              const active = []
              const inActive = []
              let lastId = body.lastid
              if (totalCams) {
                if(selectedClient.length===0){
                 totalCams=totalCams.filter(item=>clientIdsIND.includes(item.clientid))

                 setTotalData(totalCams)
                  totalCams.forEach((row) => {
                    if (row.Status === 1)
                      active.push(row)
                    else if (row.Status === 0)
                      inActive.push(row)
                  })
                  lastId = totalCams[totalCams.length-1].uid
                }
                else{
                 //totalCams = totalCams.filter(item => item.ID.some(id => selectedClient.includes(id)));
                 totalCams = totalCams.filter(item=>selectedClient.some(item2=>item2.ID===item.clientid));
                  
                 totalCams.forEach((row) => {
                    if (row.Status === 1)
                      active.push(row)
                    else if (row.Status === 0)
                      inActive.push(row)
                  })
                  lastId =totalCams.length>0?totalCams[totalCams.length-1].uid:0
                }
               
              }       
              setDevices({ 
                ...devices,
                all: totalCams ? totalCams : [],
                active: active,
                inActive: inActive,
                lastId: lastId,
                isLoad: totalCams.length === body.limit ? !devices.isLoad: devices.isLoad
                //isLoad:true
              })
              
            }

          } 
        
        })



        setDisplayAll(true)
      }
    })
  }

  const reloadClientsData = () => {
    setDevices({...devices, isLoad: !devices.isLoad})
  }

  const removeDeviceFromState = (deviceId) => {
    setAllDevices((prevDevices) => prevDevices.filter((row) => row.deviceid !== deviceId));
    setTotalData((prevTotalData) =>
      Array.isArray(prevTotalData) ? prevTotalData.filter((row) => row.deviceid !== deviceId) : []
    );
  }



  const handleDisplay = () =>{
    setDisplayAll(false)
  }

 
 
  const updateClientDevices=(devices)=>{  
    setDevices(devices)
  }

  
  const handleClientChange = (value) => {   
    if(valueMain === "us"){
      
      
      if(value.length>0){
       
        if(value.length===filteredClientListUS.length){
          setSelectedClient(value);
          if(Object.keys(totalData).length>0){
            loadFillDevices(totalData)
          }
        }
        else{
          setSelectedClient(value);
          //console.log(devices)
          let id=value.map(item=>item.ID)
          if(!displayAll){
            let clientDevices=totalData.filter(item => id.includes(item.clientid))
            loadFillDevices(clientDevices)
          }
          else{
            //console.log(devices)
            let updatedDevices=devices.all.filter(item => id.includes(item.clientid))
            loadFillDevices(updatedDevices)
          }
         
          
        }
      }
        else{
          if(Object.keys(totalData).length>0){
            loadFillDevices(totalData)
            setSelectedClient([])
          }
        }
    }
    else{
      
      //console.log(value)
      if(value.length>0){
       
        if(value.length===filteredClientListINDIA.length){
          setSelectedClient(value);
          if(Object.keys(totalData).length>0){
            loadFillDevices(totalData)
          }
        }
        else{
          setSelectedClient(value);
          //console.log(devices)
          let id=value.map(item=>item.ID)
          if(!displayAll){
            
            let clientDevices=totalData.filter(item => id.includes(item.clientid))
            loadFillDevices(clientDevices)
          }
          else{
            //console.log(devices)
            let updatedDevices=devices.all.filter(item => id.includes(item.clientid))
            loadFillDevices(updatedDevices)
          }
         
          
        }
      }
        else{
          if(Object.keys(totalData).length>0){
            loadFillDevices(totalData)
            setSelectedClient([])
          }
        }

    }

  };

  const loadFillDevices = (data)=>{
      let totalCams=data
      const active = []
      const inActive = []
      let lastId = 0
      if(totalCams.length!==0){
        totalCams.forEach((row) => {
          if (row.Status === 1)
            active.push(row)
          else if (row.Status === 0)
            inActive.push(row)
        })
      }

      let obj = {
        isLoad: true,
        all: totalCams,
        active: active,
        inActive: inActive,
        lastId: lastId
      }
      updateClientDevices(obj)
  }  

  const [dialog, setOpen] = useState({ isOpen: false, id: null });
  const [moremenu, setOpenMenu] = useState({ isOpen: false, id: null });

  function handleDialog(id=null) {
   
    setOpen({...dialog, isOpen: true, id: id})
  }

  function handleMoremenu(id=null) {
   
    setOpenMenu({...moremenu, isOpen: true, id: id})
  }

  



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const handleChangeMain = (event, newValue) => { 
    // console.log(selectedClient)
    if(selectedClient.length>0){
      setSelectedClient([])
    }
    setValueMain(newValue)
  };

  const handleEnvironmentTypeChange = (nextEnvironmentType) => {
    setEnvironmentType(nextEnvironmentType);
    setSelectedClient([]);
    setClientId([]);
    setDisplayAll(false);
  };

  const filterClientListByEnvironment = (clientList) =>
    clientList.filter((clientItem) => matchesEnvironment(clientItem));

  const filteredClientListUS = filterClientListByEnvironment(clientListUS);
  const filteredClientListINDIA = filterClientListByEnvironment(clientListINDIA);





  return (
    <Page title="Cameras">
      <Container maxWidth="xxl" sx={{ p: 0 }}>

        <DeviceForm key={dialog} dialogData={dialog} setOpen={setOpen} reloadClientsData={reloadClientsData} handleReloadPage={handleReloadPage} isReseller={isReseller}/>
        <DeviceDetails dialogData={moremenu} setOpen={setOpenMenu} reloadClientsData={reloadClientsData} handleReloadPage={handleReloadPage}/>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Cameras</Typography>
            <Button variant="contained" onClick={() => handleDialog()} component={RouterLink} to="#" startIcon={<Iconify icon="eva:plus-fill" />}>
              Add Camera
            </Button>
          </Box>
          {/* <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Cameras</Typography>
          </Breadcrumbs> */}
        </Box>
        <Card>
          <TabContext value={valueMain}>
            {!isReseller && <TabList
              onChange={handleChangeMain}
              aria-label="Country tabs"
              sx={tabListSx}
            >
              <Tab label="US" value="us" />
              <Tab label="INDIA" value="india" />
            </TabList>}

            <TabPanel value="india" sx={{ p: 0 }}>
            <TabContext value={value}>
            <TabList
                onChange={handleChange}
                aria-label="wrapped label tabs example"
                sx={tabListSx}
              >
                <Tab
                  key="all"
                  value="one"
                  icon={<Label sx={{ mr: 1 }} color='primary'>{devices.all.length}</Label>} 
                  style={{ minHeight: "auto" }}
                  iconPosition="start"
                  label="All"                  
                />
                <Tab 
                key="active"
                value="two"
                label="Active"
                icon={<Label sx={{ mr: 1 }} color='success'>{devices.active.length}</Label>} 
                style={{ minHeight: "auto" }}
                iconPosition="start"
                
                />
                <Tab 
                key="inactive"
                value="three" 
                label="In Active"
                icon={<Label sx={{ mr: 1 }} color='error'>{devices.inActive.length}</Label>} 
                style={{ minHeight: "auto" }}
                iconPosition="start"
                   />
              </TabList>

              <TabPanel kay="one" value="one" index={0} sx={{ p: 0}}>
                
                <DeviceList key="one" clientInfo={filteredClientListINDIA} totalData={totalData} total={devices.all} handleDialog={handleDialog} handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId} updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData} timezoneDetails={timezoneDetails} apiResponse={apiResponse} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>

              <TabPanel kay="Two" value="two" index={1} sx={{ p: 0}}>
                <DeviceList key="two" clientInfo={filteredClientListINDIA} totalData={totalData} total={devices.active} handleDialog={handleDialog} handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId} updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData} timezoneDetails={timezoneDetails} apiResponse={apiResponse} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>

              <TabPanel  kay="three" value="three" index={2} sx={{ p: 0}}>
                <DeviceList key="three" clientInfo={filteredClientListINDIA} totalData={totalData} total={devices.inActive} handleDialog={handleDialog}  handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId}  updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData} timezoneDetails={timezoneDetails} apiResponse={apiResponse} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>
              
          </TabContext>
            </TabPanel>

            <TabPanel value="us" sx={{ p: 0 }}>
            <TabContext value={value}>
            <TabList
                onChange={handleChange}
                aria-label="wrapped label tabs example"
                sx={tabListSx}
              >
                <Tab
                  key="all"
                  value="one"
                  icon={<Label sx={{ mr: 1 }} color='primary'>{devices.all.length}</Label>} 
                  style={{ minHeight: "auto" }}
                  iconPosition="start"
                  label="All"                  
                />
                <Tab 
                key="active"
                value="two"
                label="Active"
                icon={<Label sx={{ mr: 1 }} color='success'>{devices.active.length}</Label>} 
                style={{ minHeight: "auto" }}
                iconPosition="start"
                
                />
                <Tab 
                key="inactive"
                value="three" 
                label="In Active"
                icon={<Label sx={{ mr: 1 }} color='error'>{devices.inActive.length}</Label>} 
                style={{ minHeight: "auto" }}
                iconPosition="start"
                   />
              </TabList>

              <TabPanel kay="one" value="one" index={0} sx={{ p: 0}}>
                
                <DeviceList key="one" clientInfo={filteredClientListUS} totalData={totalData} total={devices.all} handleDialog={handleDialog} handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId} updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData}  timezoneDetails={timezoneDetails} apiResponse={apiResponse} isReseller={isReseller} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>

              <TabPanel kay="Two" value="two" index={1} sx={{ p: 0}}>
                <DeviceList key="two" clientInfo={filteredClientListUS} totalData={totalData} total={devices.active} handleDialog={handleDialog} handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId} updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData}  timezoneDetails={timezoneDetails} apiResponse={apiResponse} isReseller={isReseller} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>

              <TabPanel  kay="three" value="three" index={2} sx={{ p: 0}}>
                <DeviceList key="three" clientInfo={filteredClientListUS} totalData={totalData} total={devices.inActive} handleDialog={handleDialog}  handleMoremenu={handleMoremenu} reloadClientsData={reloadClientsData} getClientid={getClientId}  updateClientDevices={updateClientDevices} selectedClient={selectedClient} onClientChange={handleClientChange} handleReloadPage={handleReloadPage} handleDisplay={handleDisplay} setTotalData={setTotalData}  timezoneDetails={timezoneDetails} apiResponse={apiResponse} isReseller={isReseller} removeDeviceFromState={removeDeviceFromState} environmentType={environmentType} onEnvironmentTypeChange={handleEnvironmentTypeChange}/>
              </TabPanel>
              
          </TabContext>
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}
